import { createIdSlice } from '../utils/action/createElementSlice';
export const DragModeState = createIdSlice({
    elementName: 'dragMode',
    initialState: {},
    reducers: {
        init(_state, action) {
            return action.payload.data;
        },
        setCurrentMode(state, action) {
            if (!state) {
                return;
            }
            return Object.assign(Object.assign({}, state), { currentMode: action.payload.data });
        },
    },
});
